<template>
    <div class="page course-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div class="search">
            <van-search v-model="value" @click="$router.push({name:'search'})" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
        </div>

        <div class="swipe">
            <van-swipe :autoplay="3000" indicator-color="#fff">
                <van-swipe-item v-for="(item,i) in banners" :key="i">
                    <a @click.prevent="toLink(item.target_url)">
                    <!-- <a :href="item.target_url.replace('https://care-yyh.com','https://care-yyh.com')"> -->
                        <img :src="item.img" alt="">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>

        <div v-if="list && list.length > 0" class="course-list-section" style="margin-top: 22px">
            <van-row @click="go_detail(item)" v-for="item in list" :key="item.id">
                <div class="course-list-section-box">
                    <div class="course-list-section-left">
                        <van-image
                            fit="cover"
                            class="course-list-section-left-img"
                            :src="item.cover_img"
                            width="100%"
                            height="81"
                        />
                        <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/img/icon_list_tag_column.svg" alt="">
                    </div>
                    <div class="course-list-section-right">
                        <div class="course-list-section-right-title">{{item.title}}</div>
                        <div class="course-list-section-right-author" v-if="item.type != 2">{{item.doctor}} · {{item.hospital}}</div>
                        <div class="course-list-section-right-author" v-else>{{item.course_desc}}</div>
                        <div class="course-list-section-right-detail">{{item.view_count}}人学习</div>
                    </div>
                </div>
            </van-row>
        </div>
        <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
            <template slot="description">
                <!--<div style="text-align: center">已到底部</div>-->
                <div style="text-align: center">博医同行持续更新中…</div>
                <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    import {LocationHref} from '@/util/common'

    export default {
        name: 'course-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true
            }
        },
        methods: {
            toLink(url){
                const links = url.replace('https://care-yyh.com', '')
                LocationHref(links)
            },
            onSearch(){
                this.fetch('course')
            },
            onCancel() {
                this.value = ""
                this.fetch("course")
            },
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get', Interface.banner, {type: 1}).then((res) => {
                        this.banners = res.data
                    })
                } else if (scene === 'category') {
                    Interface.getData('get', Interface.course.category).then((res) => {
                        this.categories = res.data
                        this.categories.unshift({name:"推荐",id:0})
                        if(this.categories.length < 5){
                            for(let i=999;i<= (1007 - this.categories.length);i++){
                                this.categories_child.push({name:"",id:i})
                            }
                        }
                    })
                } else if (scene === 'course') {
                    let params = {
                        category_id : this.category_id,
                        pageSize:999
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.course.list,params).then((res) => {
                        this.list = res.data.list
                        Interface.getShareInfo(this,"行业大咖精品课——博医同行","","")
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                this.fetch('course')
            },
            go_detail(item){
                if (item.type === 1){
                    this.$router.push({name:'course-detail',params: { id: item.id }})
                }else{
                    this.$router.push({'name':'course-column',params:{id:item.id}})
                }
            }
        },
        created() {
            this.fetch('banner')
            this.fetch('category')
            this.fetch('course')
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/course/list/index.vue